export interface Category {
  name: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Explore curated sneaker and shoe finds updated daily with the latest drops.',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Cozy hoodies and sweaters from trending brands, organized for easy browsing.',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Graphic tees, basics, and statement pieces all in one spreadsheet.',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-windy-line',
    description: 'Outerwear collection spanning bombers, denim jackets, and winter coats.',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-scissors-line',
    description: 'Jeans, cargos, shorts and trousers organized by fit and style.',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-base-station-line',
    description: 'Caps, beanies, and bucket hats from the most popular brands.',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Matching sets and coordinated outfits for a complete look.',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-box-3-line',
    description: 'Essential basics and premium underwear options curated for quality.',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    description: 'Sports jerseys and athletic wear from top leagues and teams.',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Watches, sunglasses, jewelry and more to complete any outfit.',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    description: 'Backpacks, crossbody bags, and luxury totes at your fingertips.',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-links-line',
    description: 'Designer belts and everyday staples organized by brand and style.',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    description: 'Fragrance finds from niche to designer, organized in our database.',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Everything else — home goods, gadgets, and unexpected finds.',
  },
];